import Screen from './screen';

export default {
    path: '/login',
    auth: false,
    component: Screen,
}